import * as actions from '../actions/network-actions';

const initialState = {};

export default function networks(state = initialState, action = {}) {
  switch (action.type) {
    case actions.NETWORK_SUCCESS:
      return Object.assign({}, state, {
        [action.fetchedNetwork['company_id']]: action.fetchedNetwork
      });

    default:
      return state;
  }
}

export const getNetwork = (networkId, state) => state.networks[networkId];
export const getFiltersForNetwork = (networkId, state) => ({
  ...state.filters,
  fields: {
    ...state.filters.fields,
    network: {
      id: 'network',
      label: 'Network',
      value: { value: networkId, label: '' }
    }
  }
});
